import React from 'react';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import { captureException } from '@sentry/minimal';
import { useConfig } from '../Config';
import { config } from '../../utils';

interface AnalyticsProviderProps {
  children: React.ReactNode[] | React.ReactNode;
}

/**
 * Matomo analytics provider component which passes down a set of
 * tracking utility functions e.g. 'trackPageView', 'trackEvent' etc
 * via the the 'useMatomo' hook
 *
 * @param children - The React children components to wrap with the provider
 * @returns AnalyticsProvider component with children
 */
export const AnalyticsProvider: React.FC = ({ children }: AnalyticsProviderProps) => {
  const {
    tenantIntegrations: { analyticsId },
  } = useConfig();

  if (analyticsId && analyticsId > 0) {
    const instance = createInstance({
      urlBase: config.MATOMO_URL,
      siteId: analyticsId,
      disabled: config.ENV !== 'production',
      configurations: {
        disableCookies: true,
      },
    });

    return <MatomoProvider value={instance}>{children}</MatomoProvider>;
  }

  captureException(Error('Matomo id missing, provider value will be set to null'));
  return <MatomoProvider value={null}>{children}</MatomoProvider>;
};

export default AnalyticsProvider;
